import React from 'react';
import EditSectionLabel from '../../../../presentation/EditSectionLabel';
import EditSectionDropdown from '../../../../presentation/EditSectionDropdown';
import RouteTitle from '../../../../presentation/RouteTitle';
import EtelAPI from '../../../../api/EtelAPI';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Alerts from '../../../../prototypes/Alerts';
import Overlay from '../../../../presentation/Overlay';
import clone from 'clone';
import { clearUserProfile } from '../../../../redux/actions/user';
import { clearBugsnagUser } from '../../../../redux/actions/bugsnag';

import {
  Dialog
  , DialogHeader
  , DialogBody
  , DialogFooter
} from '../../../../presentation/Dialog';


import {
  MultiLevelGrid,
  MultiLevelGridHeader,
  MultiLevelGridHeaderColumn,
  MultiLevelGridBody,
  MultiLevelGridRow,
  MultiLevelGridRowLabelCell,
  MultiLevelGridRowTextBoxCell,
  MultiLevelGridRowDropdownCell,
  MultiLevelGridRowButtonCell,
} from '../../../../presentation/MultiLevelGrid';

class PaymentWorksheet extends React.Component {

  constructor( props ){
    super( props );

    this.now = new Date();
    this.year = this.now.getFullYear();
    this.month = this.now.getMonth(); // offset to 1 through 12
    if( this.month < 10 ) {
      this.month = '0' + this.month.toString();
    } else {
      this.month = this.month.toString();
    }

    this.UPDATE_TICK = 60000;
    this.UPDATE_INTERVAL = 0;
    this.MAXIMUM_YEARS_BACK = 5;
    this.columns = {

      /* Payments */
      'PAYMENTS': {
        'PAYEE': { text: 'Payee', width: '10%', align: 'left', visible: true },
        'TRAFFIC_PROVIDER': { text: 'Traffic Provider', width: '10%', align: 'left', visible: true },
        'PAYOUT_CODE': { text: 'Payout Code', width: '5%', align: 'left', visible: true },
        'PAYOUT_DESCRIPTION': { text: 'Description', width: '20%', align: 'left', visible: true },
        'PAYOUT_GROSS': { text: 'Payout Gross', width: '5%', align: 'right', visible: true },
        'PAYOUT_ADJUSTMENT': { text: 'Payout Adjustment', width: '5%', align: 'right', visible: true },
        'PAYOUT_NET': { text: 'Payout Net', width: '5%', align: 'right', visible: true },
        'PAYOUT_STATUS': { text: 'Payout Status', width: '20%', align: 'left', visible: true }
      },
      'ITEMIZED_PAYOUT': {
        'PAYEE': { text: 'Payee', width: '10%', align: 'left', visible: true },
        'TRAFFIC_PROVIDER': { text: 'Traffic Provider', width: '10%', align: 'left', visible: true },
        'PAYOUT_CODE': { text: 'Payout Code', width: '5%', align: 'left', visible: true },
        'PAYOUT_DESCRIPTION': { text: 'Description', width: '20%', align: 'left', visible: true },
        'PAYOUT_GROSS': { text: 'Payout Gross', width: '5%', align: 'right', visible: true },
        'PAYOUT_ADJUSTMENT': { text: 'Payout Adjustment', width: '5%', align: 'right', visible: true },
        'PAYOUT_NET': { text: 'Payout Net', width: '5%', align: 'right', visible: true },
        'ADJUSTMENT_NOTE': { text: 'Payout Adjustment', width: '30%', align: 'right', visible: true },
      },
      'ADJUSTMENTS': {
        'PAYOUT_DESCRIPTION': { text: 'Description', width: '200px', align: 'left', visible: true },
        'PAYOUT_CODE': { text: 'Code', width: '100px', align: 'right', visible: true },
        'PAYOUT_ADJUSTMENT': { text: 'Adjustment', width: '125px', align: 'right', visible: true },
        'ADJUSTMENT_NOTE': { text: 'Notes', width: '300px', align: 'left', visible: true },
      }
    };

    this.state = {
      loading: true,
      wholesaleclients: [],
      paymentstatus: [],
      paymentyears: [],
      paymentmonths: [],
      wholesalepayments: [],
      CLIENT_ID: -1,
      PAYMENT_STATUS: '',
      PAYMENT_YEAR: this.year,
      PAYMENT_MONTH: this.month,
      showadjustments: false,
      wholesalepayment: undefined,
      manual_adjustments: [],
      expanded: []
    };

    this.onChangeClient = this.onChangeClient.bind( this );
    this.onChangeStatus = this.onChangeStatus.bind( this );
    this.onChangeYear = this.onChangeYear.bind( this );
    this.onChangeMonth = this.onChangeMonth.bind( this );
    this.onApprove = this.onApprove.bind( this );
    this.onUnapprove = this.onUnapprove.bind( this );
    this.onResend = this.onResend.bind( this );
    this.onAdjust = this.onAdjust.bind( this );
    this.onAddNewAdjustment = this.onAddNewAdjustment.bind( this );
    this.onDeleteAdjustment = this.onDeleteAdjustment.bind( this );
    this.onSaveAdjustments = this.onSaveAdjustments.bind( this );
    this.onCloseAdjustments = this.onCloseAdjustments.bind( this );
    this.onChangeAdjustment = this.onChangeAdjustment.bind( this );
    this.onSetExpandedState = this.onSetExpandedState.bind( this );
  }

  /* COMPONENT FUNCTIONS */
  componentDidMount(){

    const filter = {
      CLIENT_ID: this.state.CLIENT_ID
      ,PAYMENT_STATUS: this.state.PAYMENT_STATUS
      ,PAYMENT_YEAR: this.state.PAYMENT_YEAR
      ,PAYMENT_MONTH: this.state.PAYMENT_MONTH
    };

    const getFilter = () => {
      return {
        CLIENT_ID: this.state.CLIENT_ID
        ,PAYMENT_STATUS: this.state.PAYMENT_STATUS
        ,PAYMENT_YEAR: this.state.PAYMENT_YEAR
        ,PAYMENT_MONTH: this.state.PAYMENT_MONTH
      };
    };

    this.fetchData( filter );

    const refreshPayments = () =>{
      this.fetchData( getFilter() );
    };

    this.UPDATE_INTERVAL = setInterval( function(){
      refreshPayments();
    },
    this.UPDATE_TICK
    );
  }

  componentWillUnmount(){

    if( this.UPDATE_INTERVAL !== 0 ){
      clearInterval( this.UPDATE_INTERVAL );
      this.UPDATE_INTERVAL = 0;
    }

  }

  doLogOff( ) {
    const { dispatch } = this.props;
    const auth = this.props.auth;
    const history = this.props.history;
    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }

  onHandleException( e ) {
    const title = 'Wholesale Payment Worksheet - EOM';
    const bugsnag = this.props.bugsnag;
    const { dispatch } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    const status = e.status === undefined ? 0 : e.status;
    if( status === 410 ) {
      alerts.INFO( title, 'Your session has expired.' , 5000 );
      this.doLogOff();
    } else if( status === 500 ) {
      alerts.INFO( title, e.statusText , 5000 );
      this.doLogOff();
    } else {
      alerts.CRITICAL( title, e );
    }
  }

  fetchData( filter ) {

    this.getWholesaleClientOptions( filter ).then( ( wholesaleclients ) => {

      this.getPaymentStatusOptions( filter ).then( ( paymentstatus ) => {

        this.getPaymentYearOptions( filter ).then( ( paymentyears ) => {

          this.getPaymentMonthOptions( filter ).then( ( paymentmonths ) => {

            this.getWholesalePayments( filter ).then( ( wholesalepayments ) => {
              this.setState( {
                wholesaleclients: wholesaleclients,
                paymentstatus: paymentstatus,
                paymentyears: paymentyears,
                paymentmonths: paymentmonths,
                wholesalepayments: wholesalepayments
              } );

            } ).catch( ( exception ) => {
              this.onHandleException( exception );
            } );

          } ).catch( ( exception ) => {
            this.onHandleException( exception );
          } );

        } ).catch( ( exception ) => {
          this.onHandleException( exception );
        } );

      } ).catch( ( exception ) => {
        this.onHandleException( exception );
      } );

    } ).catch( ( exception ) => {
      this.onHandleException( exception );
    } );

  }

  /* DATA FUNCTIONS */
  getWholesaleClientOptions( filter ) {
    let parameters = [];
    let CCFileYYYYMM = filter.PAYMENT_YEAR + filter.PAYMENT_MONTH;
    let Current_Status = filter.PAYMENT_STATUS;

    return new Promise( function( resolve, reject ) {

      Current_Status = Current_Status === undefined ? '' : Current_Status;

      parameters.push( {
        'CCFileYYYYMM': CCFileYYYYMM
      } );

      parameters.push( {
        'Current_Status': Current_Status
      } );

      let api = new EtelAPI( 'wholesale/payments/clients' );
      let options = [];

      options.push( { id: -1, text: '(All)' } );

      api.get( parameters ).then( ( result ) => {

        const wholesaleclient_rows = result;

        if( wholesaleclient_rows !== undefined ) {
          if( wholesaleclient_rows.length > 0 ) {
            for( var index = 0; index < wholesaleclient_rows.length; index++ ) {
              const wholesaleclient_row = wholesaleclient_rows[ index ];
              options.push( { id: wholesaleclient_row.Company_ID, text: wholesaleclient_row.Company } );
            }
          }
        }

        resolve( options );

      } ).catch( ( error ) =>{
        reject( error );
      } );

    } );

  }

  getPaymentStatusOptions( filter ) {

    return new Promise( function( resolve, reject ) {

      try {

        let options = [];

        options.push( {'id':'','text':'(All)'} );
        options.push( {'id':'Unapproved','text':'Unapproved'} );
        options.push( {'id':'Approved','text':'Approved'} );
        options.push( {'id':'Approved and Sent','text':'Approved and Sent'} );

        resolve( options );

      } catch ( e ) {
        reject( e );
      }
    } );
  }

  getPaymentYearOptions( filter ) {
    var options = [];
    let api = new EtelAPI( 'wholesale/payments/years' );
    let parameters = [];

    return new Promise( function( resolve, reject ){

      api.get( parameters ).then( ( result ) => {

        const year_rows = result;

        if( year_rows !== undefined ) {
          if( year_rows.length > 0 ) {
            for( var index = 0; index < year_rows.length; index++ ) {
              const year_row = year_rows[ index ];
              options.push( { id: parseInt( year_row.PAYMENT_YEAR, 0 ), text: year_row.PAYMENT_YEAR.toString() } );
            }
          }
        }

        resolve( options );

      } ).catch( ( error ) => {

        reject( error );

      } );

    } );

  }

  getPaymentMonthOptions( filter ) {

    return new Promise( function( resolve, reject ) {

      try {

        let options = [];

        options.push( { 'id': '01', 'text': 'January' } );
        options.push( { 'id': '02', 'text': 'February' } );
        options.push( { 'id': '03', 'text': 'March' } );
        options.push( { 'id': '04', 'text': 'April' } );
        options.push( { 'id': '05', 'text': 'May' } );
        options.push( { 'id': '06', 'text': 'June' } );
        options.push( { 'id': '07', 'text': 'July' } );
        options.push( { 'id': '08', 'text': 'August' } );
        options.push( { 'id': '09', 'text': 'September' } );
        options.push( { 'id': '10', 'text': 'October' } );
        options.push( { 'id': '11', 'text': 'November' } );
        options.push( { 'id': '12', 'text': 'December'} );

        resolve( options );

      } catch ( e ) {
        reject( e );
      }

    } );
  }

  getMonth( month ) {
    switch( month ){
    case '01': return 'January';
    case '02': return 'February';
    case '03': return 'March';
    case '04': return 'April';
    case '05': return 'May';
    case '06': return 'June';
    case '07': return 'July';
    case '08': return 'August';
    case '09': return 'September';
    case '10': return 'October';
    case '11': return 'November';
    case '12': return 'December';
    default: return 'January';
    }
  }

  getWholesalePayments( filter ) {
    const CCFileYYYYMM = this.state.PAYMENT_YEAR.toString() + this.state.PAYMENT_MONTH.toString();
    const CLIENT_ID = this.state.CLIENT_ID;
    const PAYMENT_STATUS = this.state.PAYMENT_STATUS;
    let parameters = [];

    return new Promise( function( resolve, reject ) {

      parameters.push( {
        'CCFileYYYYMM': CCFileYYYYMM
      } );

      if( parseInt( CLIENT_ID, 10 ) !== -1 ){
        parameters.push( {
          'Company_ID': CLIENT_ID
        } );
      }

      if( PAYMENT_STATUS !== '' ){
        parameters.push( {
          'Current_Status': PAYMENT_STATUS
        } );
      }

      let api = new EtelAPI( 'wholesale/payments' );

      api.get( parameters ).then( ( result )=> {

        resolve( result );

      } ).catch( ( error ) => {

        reject( error );

      } );

    } );

  }

  getPaymentInfo(){
    const monthEnd = this.getMonth( this.state.PAYMENT_MONTH ) + ' ' + this.state.PAYMENT_YEAR.toString();
    const wholesalepayments = this.state.wholesalepayments;
    let total = 0;
    let unapproved = 0;
    let approved = 0;
    let approved_and_sent = 0;

    if( wholesalepayments !== undefined ){

      total = wholesalepayments.length;

      if( wholesalepayments !== undefined ) {
        if( wholesalepayments.lengtn > 0 ) {
          for( var index = 0; index < wholesalepayments.length; index++ ) {
            const wholesalepayment = wholesalepayments[ index ];
            if( wholesalepayment.PAYOUT_STATUS === 'Unapproved' ){
              unapproved += 1;
            }
            if( wholesalepayment.PAYOUT_STATUS === 'Approved' ){
              approved += 1;
            }
            if( wholesalepayment.PAYOUT_STATUS === 'Approved and Sent' ){
              approved_and_sent += 1;
            }
          }
        }
      }
    }

    let paymentInfo = {
      'Month End': monthEnd,
      'Unapproved': unapproved,
      'Approved': approved,
      'Sent': approved_and_sent,
      'Total': total
    };

    return ( paymentInfo );
  }

  getColumnInfo( category, column ){
    const { dispatch } = this.props;
    const Bugsnag = this.props.bugsnag;
    let selected_column = undefined;

    try {

      const selected_category = this.columns[category];

      selected_column = selected_category[ column ];

    } catch( error ) {

      let alerts = new Alerts( Bugsnag, dispatch );
      alerts.CRITICAL( 'Wholesale Payment Worksheet - EOM', error );

      return undefined;
    }

    return selected_column;
  }

  /* RENDER FUNCTIONS */
  onRenderFilter(){

    const wholesaleclients = this.state.wholesaleclients;
    const paymentstatus = this.state.paymentstatus;
    const paymentyears = this.state.paymentyears;
    const paymentmonths = this.state.paymentmonths;

    return (
      <div key='payment-worksheet-filter-row'>
        <span className='payment-worksheet-filter-control'>
          <EditSectionLabel id='lblClient' Text='Client' width='60px' />
          <EditSectionDropdown id='ddlClient' width='200px' value={this.state.CLIENT_ID} options={wholesaleclients} onChanged={this.onChangeClient} />
        </span>
        <span className='payment-worksheet-filter-control'>
          <EditSectionLabel id='lblStatus' Text='Status' width='60px' />
          <EditSectionDropdown id='ddlStatus' width='200px' value={this.state.PAYMENT_STATUS} options={paymentstatus} onChanged={this.onChangeStatus} />
        </span>
        <span className='payment-worksheet-filter-control'>
          <EditSectionLabel id='lblYear' Text='Year' width='60px' />
          <EditSectionDropdown id='ddlYear' width='200px' value={this.state.PAYMENT_YEAR} options={paymentyears} onChanged={this.onChangeYear} />
        </span>
        <span className='payment-worksheet-filter-control'>
          <EditSectionLabel id='lblMonth' Text='Month' width='60px' />
          <EditSectionDropdown id='ddlMonth' width='200px' value={this.state.PAYMENT_MONTH} options={paymentmonths} onChanged={this.onChangeMonth} />
        </span>
      </div>
    );
  }

  onRenderHeader(){

    const display_columns = [
      'PAYEE',
      'TRAFFIC_PROVIDER',
      'PAYOUT_CODE',
      'PAYOUT_DESCRIPTION',
      'PAYOUT_GROSS',
      'PAYOUT_ADJUSTMENT',
      'PAYOUT_NET',
      'PAYOUT_STATUS',
    ];

    /* Build the headers based off this.columns definitions */
    let headers = display_columns.map( ( display_column ) =>{
      const column = this.getColumnInfo( 'PAYMENTS', display_column );
      if( column !== undefined ){
        if( column.visible === true ) {
          return ( <MultiLevelGridHeaderColumn key={display_column} column={display_column} text={column.text} width={column.width} textAlign={column.align} /> );
        } else {
          return '';
        }
      } else {
        return '';
      }
    } );
    return ( headers );
  }

  onRenderBody( ) {
    const wholesalepayments = this.state.wholesalepayments;
    let wholesalepayment_rows = [];

    if( wholesalepayments !== undefined ){
      let rowIndex = 0;
      let payee = this.getColumnInfo( 'PAYMENTS','PAYEE' );
      let payout_gross = this.getColumnInfo( 'PAYMENTS','PAYOUT_GROSS' );
      let payout_adjustment = this.getColumnInfo( 'PAYMENTS','PAYOUT_ADJUSTMENT' );
      let payout_net = this.getColumnInfo( 'PAYMENTS','PAYOUT_NET' );
      let payment_status = this.getColumnInfo( 'PAYMENTS','PAYOUT_STATUS' );

      if( wholesalepayments.length > 0 ) {
        let altrow = false;

        for( var index = 0; index < wholesalepayments.length; index++ ) {
          const wholesalepayment = wholesalepayments[index];
          const itemized_payout = wholesalepayments[index]['ITEMIZED_PAYOUT'];
          let rowkey = 'wholesale-payement-row-' + index.toString();
          //const gross = parseFloat( wholesalepayment.PAYOUT_GROSS, 10 );
          //const net = parseFloat( wholesalepayment.PAYOUT_NET, 10 );

          //if( gross !== 0.00 && net !== 0.00 ) {

          let buttons = [];

          if( wholesalepayment.PAYOUT_STATUS === 'Unapproved' ){
            buttons.push( <MultiLevelGridRowButtonCell btnClass="multi-level-grid-row-cell-button" key="btnApprove" text="Approve" width="5.5%" eventargs={wholesalepayment} onButtonClick={this.onApprove} /> );
            buttons.push( <MultiLevelGridRowButtonCell btnClass="multi-level-grid-row-cell-button adjust-button" key="btnAdjust" text="Adjust" width="5%" eventargs={wholesalepayment} onButtonClick={this.onAdjust} /> );
          }

          if( wholesalepayment.PAYOUT_STATUS === 'Approved' ){
            buttons.push( <MultiLevelGridRowButtonCell btnClass="multi-level-grid-row-cell-button" key="btnUnapprove" text="Unapprove" width="10%" eventargs={wholesalepayment} onButtonClick={this.onUnapprove} /> );
          }

          if( wholesalepayment.PAYOUT_STATUS === 'Approved and Sent' ){
            buttons.push( <MultiLevelGridRowButtonCell btnClass="multi-level-grid-row-cell-button" key="btnResend" text="Resend" width="10%" eventargs={wholesalepayment} onButtonClick={this.onResend} /> );
          }

          if( !altrow ) {
            wholesalepayment_rows.push(
              <MultiLevelGridRow key={rowkey} index={rowIndex} HasExpandPanel ExpandPanelChildren={this.onRenderItemizedPayout( itemized_payout )}>
                <MultiLevelGridRowLabelCell column="PAYEE" text={wholesalepayment.PAYEE} width={payee.width} textAlign={payee.align} tooltip />
                <MultiLevelGridRowLabelCell column="PAYOUT_SPACE" width="35%"/>
                <MultiLevelGridRowLabelCell column="PAYOUT_GROSS" text={wholesalepayment.PAYOUT_GROSS} width={payout_gross.width} textAlign={payout_gross.align} precision={2} format='usdollarwithcommas' tooltip />
                <MultiLevelGridRowLabelCell column="PAYOUT_ADJUSTMENT" text={wholesalepayment.PAYOUT_ADJUSTMENT} width={payout_adjustment.width} textAlign={payout_adjustment.align} precision={2} format='usdollarwithcommas' tooltip/>
                <MultiLevelGridRowLabelCell column="PAYOUT_NET" text={wholesalepayment.PAYOUT_NET} width={payout_net.width} textAlign={payout_net.align} precision={2} format='usdollarwithcommas' tooltip />
                <MultiLevelGridRowLabelCell column="PAYOUT_STATUS" text={wholesalepayment.PAYOUT_STATUS} width={payment_status.width} textAlign={payment_status.align} tooltip />
                {buttons}
              </MultiLevelGridRow>
            );
          } else {
            wholesalepayment_rows.push(
              <MultiLevelGridRow altrow key={rowkey} index={rowIndex} HasExpandPanel ExpandPanelChildren={this.onRenderItemizedPayout( itemized_payout )}>
                <MultiLevelGridRowLabelCell column="PAYEE" text={wholesalepayment.PAYEE} width={payee.width} textAlign={payee.align} tooltip />
                <MultiLevelGridRowLabelCell column="PAYOUT_SPACE" width="35%"/>
                <MultiLevelGridRowLabelCell column="PAYOUT_GROSS" text={wholesalepayment.PAYOUT_GROSS} width={payout_gross.width} textAlign={payout_gross.align} precision={2} format='usdollarwithcommas' tooltip />
                <MultiLevelGridRowLabelCell column="PAYOUT_ADJUSTMENT" text={wholesalepayment.PAYOUT_ADJUSTMENT} width={payout_adjustment.width} textAlign={payout_adjustment.align} precision={2} format='usdollarwithcommas' tooltip/>
                <MultiLevelGridRowLabelCell column="PAYOUT_NET" text={wholesalepayment.PAYOUT_NET} width={payout_net.width} textAlign={payout_net.align} precision={2} format='usdollarwithcommas' tooltip />
                <MultiLevelGridRowLabelCell column="PAYOUT_STATUS" text={wholesalepayment.PAYOUT_STATUS} width={payment_status.width} textAlign={payment_status.align} tooltip />
                {buttons}
              </MultiLevelGridRow>
            );
          }
          altrow = !altrow;
        }
      }
      //}

    } else {

      wholesalepayment_rows.push( <MultiLevelGridRowLabelCell key="no-records-found" column='NO_RECORDS_FOUND' text='No Payments Available' width='100%' textAlign='left'/> );

    }
    return( wholesalepayment_rows );
  }

  onSetExpandedState( e ) {
    let index = e.target.getAttribute( 'eventargs' );
    let expanded = this.state.expanded;
    expanded[index] = !expanded[index];
    
    this.setState( {
      expanded: expanded
    } );
  }

  onRenderMobileBody( ) {
    const wholesalepayments = this.state.wholesalepayments;
    let wholesalepayment_rows = [];

    if( wholesalepayments !== undefined ){
      if( wholesalepayments.length > 0 ) {
        let payee = this.getColumnInfo( 'PAYMENTS','PAYEE' );
        let payout_gross = this.getColumnInfo( 'PAYMENTS','PAYOUT_GROSS' );
        let payout_adjustment = this.getColumnInfo( 'PAYMENTS','PAYOUT_ADJUSTMENT' );
        let payout_net = this.getColumnInfo( 'PAYMENTS','PAYOUT_NET' );
        let payment_status = this.getColumnInfo( 'PAYMENTS','PAYOUT_STATUS' );

        for( var index = 0; index < wholesalepayments.length; index++ ) {
          const wholesalepayment = wholesalepayments[index];
          const itemized_payout = wholesalepayments[index]['ITEMIZED_PAYOUT'];
          let rowkey = 'wholesale-payement-row-' + index.toString();
          const gross = parseFloat( wholesalepayment.PAYOUT_GROSS, 10 );
          const net = parseFloat( wholesalepayment.PAYOUT_NET, 10 );

          if( gross !== 0.00 && net !== 0.00 ) {

            let buttons = [];

            if( wholesalepayment.PAYOUT_STATUS === 'Unapproved' ){
              buttons.push( <MultiLevelGridRowButtonCell btnClass="multi-level-grid-row-cell-button" key="btnApprove" text="Approve" width="5.5%" eventargs={wholesalepayment} onButtonClick={this.onApprove} /> );
              buttons.push( <MultiLevelGridRowButtonCell btnClass="multi-level-grid-row-cell-button adjust-button" key="btnAdjust" text="Adjust" width="5%" eventargs={wholesalepayment} onButtonClick={this.onAdjust} /> );
            }

            if( wholesalepayment.PAYOUT_STATUS === 'Approved' ){
              buttons.push( <MultiLevelGridRowButtonCell btnClass="multi-level-grid-row-cell-button" key="btnUnapprove" text="Unapprove" width="10%" eventargs={wholesalepayment} onButtonClick={this.onUnapprove} /> );
            }

            if( wholesalepayment.PAYOUT_STATUS === 'Approved and Sent' ){
              buttons.push( <MultiLevelGridRowButtonCell btnClass="multi-level-grid-row-cell-button" key="btnResend" text="Resend" width="10%" eventargs={wholesalepayment} onButtonClick={this.onResend} /> );
            }

            wholesalepayment_rows.push(
              <div key={rowkey} className="payments-row">
                <div><span>PAYEE:</span> <MultiLevelGridRowLabelCell column="PAYEE" text={wholesalepayment.PAYEE} textAlign={payee.align} tooltip /></div>
                <div><span>PAYOUT GROSS:</span> <MultiLevelGridRowLabelCell column="PAYOUT_GROSS" text={wholesalepayment.PAYOUT_GROSS} textAlign={payout_gross.align} precision={2} format='usdollarwithcommas' tooltip /></div>
                <div><span>PAYOUT ADJUSTMENT:</span> <MultiLevelGridRowLabelCell column="PAYOUT_ADJUSTMENT" text={wholesalepayment.PAYOUT_ADJUSTMENT} textAlign={payout_adjustment.align} precision={2} format='usdollarwithcommas' tooltip/></div>
                <div><span>PAYOUT NET:</span> <MultiLevelGridRowLabelCell column="PAYOUT_NET" text={wholesalepayment.PAYOUT_NET} textAlign={payout_net.align} precision={2} format='usdollarwithcommas' tooltip /></div>
                <div><span>PAYOUT STATUS:</span> <MultiLevelGridRowLabelCell column="PAYOUT_STATUS" text={wholesalepayment.PAYOUT_STATUS} textAlign={payment_status.align} tooltip /></div>
                <div className="payment-action-buttons">{buttons}</div>
                <i className={ ( !this.state.expanded[index] ) ? 'multi-level-grid-row-expand-cell-icon icon-feather-square-plus':'multi-level-grid-row-expand-cell-icon icon-feather-square-minus' } eventargs={index} onClick={this.onSetExpandedState}></i>
                <div className={ ( this.state.expanded[index] ) ? 'payments-row-childs active':'payments-row-childs' }>{this.onRenderMobileItemizedPayout( itemized_payout )}</div>
              </div>
            );
          }
        }
      }

    } else {

      wholesalepayment_rows.push( <MultiLevelGridRowLabelCell key="no-records-found" column='NO_RECORDS_FOUND' text='No Payments Available' width='100%' textAlign='left'/> );

    }
    return( wholesalepayment_rows );
  }

  onRenderMobileItemizedPayout( itemized_payouts ){

    let itemized_payout_rows = [];
    let traffic_provider = this.getColumnInfo( 'ITEMIZED_PAYOUT','TRAFFIC_PROVIDER' );
    let payout_code = this.getColumnInfo( 'ITEMIZED_PAYOUT','PAYOUT_CODE' );
    let payout_description = this.getColumnInfo( 'ITEMIZED_PAYOUT','PAYOUT_DESCRIPTION' );
    let payout_gross = this.getColumnInfo( 'ITEMIZED_PAYOUT','PAYOUT_GROSS' );
    let payout_adjustment = this.getColumnInfo( 'ITEMIZED_PAYOUT','PAYOUT_ADJUSTMENT' );
    let payout_net = this.getColumnInfo( 'ITEMIZED_PAYOUT','PAYOUT_NET' );

    let sub_totals = {
      'PAYOUT_GROSS': 0,
      'PAYOUT_ADJUSTMENT': 0,
      'PAYOUT_NET':0,
      'PAYOUT_TOTAL': 0
    };

    if( itemized_payouts !== undefined ){

      if( itemized_payouts.length > 0 ){

        for( var index = 0; index < itemized_payouts.length; index++ ){

          let itemized_payout = itemized_payouts[index];
          let rowkey = 'itemized-payout-item-' + index;

          sub_totals['PAYOUT_GROSS'] += itemized_payout.PAYOUT_GROSS;
          sub_totals['PAYOUT_ADJUSTMENT'] += itemized_payout.PAYOUT_ADJUSTMENT;
          sub_totals['PAYOUT_NET'] += itemized_payout.PAYOUT_NET;
          sub_totals['PAYOUT_TOTAL'] += itemized_payout.PAYOUT_GROSS + itemized_payout.PAYOUT_ADJUSTMENT;

          itemized_payout_rows.push(
            <div key={rowkey} className="payments-child-row">
              <div><span>TRAFFIC PROVIDER:</span> <MultiLevelGridRowLabelCell column="TRAFFIC_PROVIDER" text={itemized_payout.TRAFFIC_PROVIDER} textAlign={traffic_provider.textAlign} tooltip /></div>
              <div><span>PAYOUT CODE:</span> <MultiLevelGridRowLabelCell column="PAYOUT_CODE" text={itemized_payout.PAYOUT_CODE} textAlign={payout_code.textAlign} tooltip /></div>
              <div><span>PAYOUT DESCRIPTION:</span> <MultiLevelGridRowLabelCell column="PAYOUT_DESCRIPTION" text={itemized_payout.PAYOUT_DESCRIPTION} textAlign={payout_description.textAlign} tooltip /></div>
              <div><span>PAYOUT GROSS:</span> <MultiLevelGridRowLabelCell column="PAYOUT_GROSS" text={itemized_payout.PAYOUT_GROSS} textAlign={payout_gross.align} precision={2} format='usdollarwithcommas' tooltip /></div>
              <div><span>PAYOUT ADJUSTMENT:</span> <MultiLevelGridRowLabelCell column="PAYOUT_ADJUSTMENT" text={itemized_payout.PAYOUT_ADJUSTMENT} textAlign={payout_adjustment.align} precision={2} format='usdollarwithcommas' tooltip /></div>
              <div><span>PAYOUT NET:</span> <MultiLevelGridRowLabelCell column="PAYOUT_NET" text={itemized_payout.PAYOUT_NET} textAlign={payout_net.align} precision={2} format='usdollarwithcommas' tooltip /></div>
            </div>
          );
        }

      } else {

        itemized_payout_rows.push(
          <MultiLevelGridRow rowkey="no-itemized-payout-row" nodivider>
            <MultiLevelGridRowLabelCell text="" width="15%" />
            <MultiLevelGridRowLabelCell text="There are no itemized payouts or adjustments for this month end." tooltip />
          </MultiLevelGridRow>
        );

      }
    } else {

      itemized_payout_rows.push(
        <MultiLevelGridRow rowkey="no-itemized-payout-row" nodivider>
          <MultiLevelGridRowLabelCell text="" width="15%" />
          <MultiLevelGridRowLabelCell text="There are no itemized payouts or adjustments for this month end." tooltip />
        </MultiLevelGridRow>
      );

    }

    return ( itemized_payout_rows );
  }

  onRenderItemizedPayout( itemized_payouts ){

    let itemized_payout_rows = [];
    let traffic_provider = this.getColumnInfo( 'ITEMIZED_PAYOUT','TRAFFIC_PROVIDER' );
    let payout_code = this.getColumnInfo( 'ITEMIZED_PAYOUT','PAYOUT_CODE' );
    let payout_description = this.getColumnInfo( 'ITEMIZED_PAYOUT','PAYOUT_DESCRIPTION' );
    let payout_gross = this.getColumnInfo( 'ITEMIZED_PAYOUT','PAYOUT_GROSS' );
    let payout_adjustment = this.getColumnInfo( 'ITEMIZED_PAYOUT','PAYOUT_ADJUSTMENT' );
    let payout_net = this.getColumnInfo( 'ITEMIZED_PAYOUT','PAYOUT_NET' );

    let sub_totals = {
      'PAYOUT_GROSS': 0,
      'PAYOUT_ADJUSTMENT': 0,
      'PAYOUT_NET':0,
      'PAYOUT_TOTAL': 0
    };

    if( itemized_payouts !== undefined ){

      if( itemized_payouts.length > 0 ){

        for( var index = 0; index < itemized_payouts.length; index++ ){

          let itemized_payout = itemized_payouts[index];
          let rowkey = 'itemized-payout-item-' + index;

          sub_totals['PAYOUT_GROSS'] += itemized_payout.PAYOUT_GROSS;
          sub_totals['PAYOUT_ADJUSTMENT'] += itemized_payout.PAYOUT_ADJUSTMENT;
          sub_totals['PAYOUT_NET'] += itemized_payout.PAYOUT_NET;
          sub_totals['PAYOUT_TOTAL'] += itemized_payout.PAYOUT_GROSS + itemized_payout.PAYOUT_ADJUSTMENT;

          itemized_payout_rows.push(
            <MultiLevelGridRow key={rowkey} nodivider>
              <MultiLevelGridRowLabelCell text="" width="15%" />
              <MultiLevelGridRowLabelCell column="TRAFFIC_PROVIDER" text={itemized_payout.TRAFFIC_PROVIDER} width={traffic_provider.width} textAlign={traffic_provider.textAlign} tooltip />
              <MultiLevelGridRowLabelCell column="PAYOUT_CODE" text={itemized_payout.PAYOUT_CODE} width={payout_code.width} textAlign={payout_code.textAlign} tooltip />
              <MultiLevelGridRowLabelCell column="PAYOUT_DESCRIPTION" text={itemized_payout.PAYOUT_DESCRIPTION} width={payout_description.width} textAlign={payout_description.textAlign} tooltip />
              <MultiLevelGridRowLabelCell column="PAYOUT_GROSS" text={itemized_payout.PAYOUT_GROSS} width={payout_gross.width} textAlign={payout_gross.align} precision={2} format='usdollarwithcommas' tooltip />
              <MultiLevelGridRowLabelCell column="PAYOUT_ADJUSTMENT" text={itemized_payout.PAYOUT_ADJUSTMENT} width={payout_adjustment.width} textAlign={payout_adjustment.align} precision={2} format='usdollarwithcommas' tooltip />
              <MultiLevelGridRowLabelCell column="PAYOUT_NET" text={itemized_payout.PAYOUT_NET} width={payout_net.width} textAlign={payout_net.align} precision={2} format='usdollarwithcommas' tooltip />
            </MultiLevelGridRow>
          );
        }

      } else {

        itemized_payout_rows.push(
          <MultiLevelGridRow rowkey="no-itemized-payout-row" nodivider>
            <MultiLevelGridRowLabelCell text="" width="15%" />
            <MultiLevelGridRowLabelCell text="There are no itemized payouts or adjustments for this month end." tooltip />
          </MultiLevelGridRow>
        );

      }
    } else {

      itemized_payout_rows.push(
        <MultiLevelGridRow rowkey="no-itemized-payout-row" nodivider>
          <MultiLevelGridRowLabelCell text="" width="15%" />
          <MultiLevelGridRowLabelCell text="There are no itemized payouts or adjustments for this month end." tooltip />
        </MultiLevelGridRow>
      );

    }

    return ( itemized_payout_rows );
  }

  onRenderTotals(){

    const paymentInfo = this.getPaymentInfo();
    const monthend = paymentInfo['Month End'];
    const unapproved = paymentInfo['Unapproved'];
    const approved = paymentInfo['Approved'];
    const sent = paymentInfo['Sent'];
    const total = paymentInfo['Total'];

    return (
      <span className="payment-worksheet-totals">
        <span>
          <span className="payment-worksheet-totals-label">
            Month End:
          </span>
          <span className="payment-worksheet-totals-value">
            {monthend}
          </span >
        </span>
        <span>
          <span className="payment-worksheet-totals-label">
            Total:
          </span>
          <span className="payment-worksheet-totals-value">
            {total}
          </span >
        </span>
        <span>
          <span className="payment-worksheet-totals-label">
            Unapproved:
          </span>
          <span className="payment-worksheet-totals-value">
            {unapproved}
          </span >
        </span>
        <span>
          <span className="payment-worksheet-totals-label">
            Approved:
          </span>
          <span className="payment-worksheet-totals-value">
            {approved}
          </span >
        </span>
        <span>
          <span className="payment-worksheet-totals-label">
            Approved and Sent:
          </span>
          <span className="payment-worksheet-totals-value">
            {sent}
          </span >
        </span>
      </span>
    );
  }

  onRenderAdjustments(){
    const wholesalepayment = this.state.wholesalepayment;
    const showadjustments = this.state.showadjustments;
    const adjustments = this.state.manual_adjustments;
    let grid = '';

    if( showadjustments === true ) {

      const display_columns = [
        'PAYOUT_DESCRIPTION',
        'PAYOUT_CODE',
        'PAYOUT_ADJUSTMENT',
        'ADJUSTMENT_NOTE'
      ];

      let headers = display_columns.map( ( display_column ) => {
        const column = this.getColumnInfo( 'ADJUSTMENTS', display_column );
        if ( column !== undefined ) {
          if ( column.visible === true ) {
            return ( <MultiLevelGridHeaderColumn key={display_column} column={display_column} text={column.text} width={column.width} textAlign={column.align}/> );
          } else {
            return '';
          }
        } else {
          return '';
        }
      } );

      let payout_description = this.getColumnInfo( 'ADJUSTMENTS','PAYOUT_DESCRIPTION' );
      let payout_code = this.getColumnInfo( 'ADJUSTMENTS','PAYOUT_CODE' );
      let payout_adjustment = this.getColumnInfo( 'ADJUSTMENTS','PAYOUT_ADJUSTMENT' );
      let adjustment_note = this.getColumnInfo( 'ADJUSTMENTS','ADJUSTMENT_NOTE' );
      let rows = [];

      for( var adjustment_index = 0; adjustment_index < adjustments.length; adjustment_index++ ) {
        const adjustment = adjustments[ adjustment_index ];
        if( adjustment !== undefined ) {
          const rowkey = 'adjustment-row-' + adjustment_index.toString();
          const payout_description_key = 'payout-description-' + adjustment_index.toString();
          const payout_code_key = 'payout-code-' + adjustment_index.toString();
          const payout_adjustment_key = 'payout-adjustment-' + adjustment_index.toString();
          const adjustment_note_key = 'adjustment-note-' + adjustment_index.toString();
          const eventargs = { rowIndex: adjustment_index };
          const payoutcode_options = [
            { 'value':'MAN_ADJ', 'text': 'Manual'},
            { 'value':'OTHER_ADJ', 'text': 'Other'}
          ];

          if( adjustment.MODE === 'NEW' || adjustment.MODE === 'EDIT' ) {
            rows.push(
              <MultiLevelGridRow key={rowkey} cellalign="topleft" nodivider>
                <MultiLevelGridRowTextBoxCell id={payout_description_key} rowIndex={adjustment_index} column="PAYOUT_DESCRIPTION" text={adjustment.PAYOUT_DESCRIPTION} width={payout_description.width} textAlign={payout_description.textAlign} onChange={this.onChangeAdjustment} placeholder="Please enter description" scrollable />
                <MultiLevelGridRowDropdownCell id={payout_code_key} rowIndex={adjustment_index} column="PAYOUT_CODE" value={adjustment.PAYOUT_CODE} width={payout_code.width} textAlign={payout_code.textAlign} onChange={this.onChangeAdjustment} options={payoutcode_options} />
                <MultiLevelGridRowTextBoxCell id={payout_adjustment_key} rowIndex={adjustment_index} column="PAYOUT_ADJUSTMENT" text={adjustment.PAYOUT_ADJUSTMENT} width={payout_adjustment.width} textAlign={payout_adjustment.textAlign} onChange={this.onChangeAdjustment} precision={2} placeholder="Adjustment in format 0.00"/>
                <MultiLevelGridRowTextBoxCell id={adjustment_note_key} rowIndex={adjustment_index} column="ADJUSTMENT_NOTE" text={adjustment.ADJUSTMENT_NOTE} width={adjustment_note.width} textAlign={adjustment_note.textAlign} onChange={this.onChangeAdjustment} placeholder="Please enter notes" scrollable />
                <MultiLevelGridRowButtonCell btnClass="delete-button" text="Delete" width="100px" onButtonClick={this.onDeleteAdjustment} eventargs={eventargs} />
              </MultiLevelGridRow>
            );
          }
        }
      }

      if( rows.length <= 0 ){
        let rowkey = 'adjustment-no-records-row';
        rows.push(
          <MultiLevelGridRow key={rowkey} style={{'paddingBottom': '5px'}} nodivider>
            <MultiLevelGridRowLabelCell text="There are no adjustments available for this summary." width="100%"/>
          </MultiLevelGridRow>
        );
      }

      grid = (
        <div>
          <div className="adjustments-dialog-button-area">
            <button className="dialog-header-add-button" onClick={this.onAddNewAdjustment}>
              Add New Adjustment
            </button>
          </div>
          <MultiLevelGrid nodivider>
            <MultiLevelGridHeader>
              {headers}
            </MultiLevelGridHeader>
            <MultiLevelGridBody>
              <span className="multi-level-grid-body-scroll-panel">
                {rows}
              </span>
            </MultiLevelGridBody>
          </MultiLevelGrid>
        </div>
      );

      let caption = 'Payment Adjustments for ' + wholesalepayment.PAYEE;
      return (
        <span className="adjustments-dialog">
          <Overlay show={true} />
          <Dialog width="60%" height="75%" show={true}>
            <DialogHeader closeButton onClose={this.onCloseAdjustments} caption={caption} />
            <DialogBody>
              {grid}
            </DialogBody>
            <DialogFooter>
              <button className="dialog-footer-cancel-button" onClick={this.onCloseAdjustments}>Cancel</button>
              <button className="dialog-footer-save-button" onClick={this.onSaveAdjustments}>Save</button>
            </DialogFooter>
          </Dialog>
        </span>
      );
    } else {
      return ( <span></span> );
    }

  }

  /* EVENT FUNCTIONS */
  onChangeClient( e ) {

    const CLIENT_ID = e.target.value;
    const PAYMENT_STATUS = this.state.PAYMENT_STATUS;
    const PAYMENT_YEAR = parseInt( this.state.PAYMENT_YEAR, 10 );
    const PAYMENT_MONTH = this.state.PAYMENT_MONTH;

    const filter = {
      CLIENT_ID: CLIENT_ID
      ,PAYMENT_STATUS: PAYMENT_STATUS
      ,PAYMENT_YEAR: PAYMENT_YEAR
      ,PAYMENT_MONTH: PAYMENT_MONTH
    };

    this.setState( {
      CLIENT_ID: CLIENT_ID
    } );

    this.fetchData( filter );

  }

  onChangeStatus( e ) {

    const CLIENT_ID = parseInt( this.state.CLIENT_ID, 10 );
    const PAYMENT_STATUS = e.target.value;
    const PAYMENT_YEAR = parseInt( this.state.PAYMENT_YEAR, 10 );
    const PAYMENT_MONTH = this.state.PAYMENT_MONTH;

    const filter = {
      CLIENT_ID: CLIENT_ID
      ,PAYMENT_STATUS: PAYMENT_STATUS
      ,PAYMENT_YEAR: PAYMENT_YEAR
      ,PAYMENT_MONTH: PAYMENT_MONTH
    };

    this.setState( {
      PAYMENT_STATUS: PAYMENT_STATUS
    } );

    this.fetchData( filter );
  }

  onChangeYear( e ) {

    const CLIENT_ID = this.state.CLIENT_ID;
    const PAYMENT_STATUS = this.state.PAYMENT_STATUS;
    const PAYMENT_YEAR = parseInt( e.target.value, 0 );
    const PAYMENT_MONTH = this.state.PAYMENT_MONTH;

    const filter = {
      CLIENT_ID: CLIENT_ID
      ,PAYMENT_STATUS: PAYMENT_STATUS
      ,PAYMENT_YEAR: PAYMENT_YEAR
      ,PAYMENT_MONTH: PAYMENT_MONTH
    };

    this.setState( {
      PAYMENT_YEAR: PAYMENT_YEAR
    } );

    this.fetchData( filter );
  }

  onChangeMonth( e ) {

    const CLIENT_ID = parseInt( this.state.CLIENT_ID, 10 );
    const PAYMENT_STATUS = this.state.PAYMENT_STATUS;
    const PAYMENT_YEAR = parseInt( this.state.PAYMENT_YEAR, 10 );
    const PAYMENT_MONTH = e.target.value;

    const filter = {
      CLIENT_ID: CLIENT_ID
      ,PAYMENT_STATUS: PAYMENT_STATUS
      ,PAYMENT_YEAR: PAYMENT_YEAR
      ,PAYMENT_MONTH: PAYMENT_MONTH
    };

    this.setState( {
      PAYMENT_MONTH: PAYMENT_MONTH
    } );

    this.fetchData( filter );
  }

  onUpdateStatus( wholesalepayment, new_status ) {
    const auth = this.props.auth;
    const user = this.props.user;
    const profile = auth.getProfile( user );
    var year = this.state.PAYMENT_YEAR.toString();
    var month = this.state.PAYMENT_MONTH.toString();
    var CCFILEYYYYMM = year + month;

    let parameters = {
      PAYEE_ID: wholesalepayment.PAYEE_ID,
      CCFILEYYYYMM: parseInt( CCFILEYYYYMM, 10 ),
      STATUS_TYPE: new_status,
      STATUS_BY: profile.name
    };

    let api = new EtelAPI( 'wholesale/payments' );

    const getFilter = () => {
      return {
        CLIENT_ID: this.state.CLIENT_ID
        ,PAYMENT_STATUS: this.state.PAYMENT_STATUS
        ,PAYMENT_YEAR: this.state.PAYMENT_YEAR
        ,PAYMENT_MONTH: this.state.PAYMENT_MONTH
      };
    };

    api.update( parameters ).then( ( result ) =>{

      if( new_status !== 'Resend' ) {
        this.fetchData( getFilter() );
      }

    } ).catch( ( exception ) => {

      this.onHandleException( exception );

    } );

  }

  onApprove( e ){
    const wholesalepayment = e.target.eventargs;
    this.onUpdateStatus( wholesalepayment, 'Approved' );
  }

  onUnapprove( e ){
    const wholesalepayment = e.target.eventargs;
    this.onUpdateStatus( wholesalepayment, 'Unapproved' );
  }

  onResend( e ){

    const wholesalepayment = e.target.eventargs;

    this.onUpdateStatus( wholesalepayment, 'Resend' );

  }

  onAdjust( e ){
    const wholesalepayment = e.target.eventargs;
    const itemized_payouts = wholesalepayment['ITEMIZED_PAYOUT'];
    let adjustments = [];
    let auth = this.props.auth;
    const user = this.props.user;
    let profile = auth.getProfile( user );
    const ADJUSTMENT_BY = profile.name;

    if( itemized_payouts !== undefined ) {
      if( itemized_payouts.length > 0 ) {
        for( var index = 0; index < itemized_payouts.length; index++ ) {
          const itemized_payout = itemized_payouts[ index ];
          if( itemized_payout.PAYOUT_CODE === 'MAN_ADJ' || itemized_payout.PAYOUT_CODE === 'OTHER_ADJ' ){
            let adjustment = {
              SUMMARY_ID: wholesalepayment.SUMMARY_ID,
              ADJUSTMENT_ID: itemized_payout.ADJUSTMENT_ID,
              PAYOUT_DESCRIPTION: itemized_payout.PAYOUT_DESCRIPTION,
              PAYOUT_ADJUSTMENT: itemized_payout.PAYOUT_ADJUSTMENT,
              PAYOUT_CODE: itemized_payout.PAYOUT_CODE,
              ADJUSTMENT_NOTE: itemized_payout.ADJUSTMENT_NOTE,
              MODE: 'EDIT',
              CHANGED: false,
              ADJUSTMENT_BY: ADJUSTMENT_BY,
            };
            adjustments.push( adjustment );
          }
        }
      }
    }

    this.setState( {
      showadjustments: true,
      manual_adjustments: adjustments,
      wholesalepayment: wholesalepayment
    } );
  }

  onAddNewAdjustment( e ){

    let wholesalepayment = this.state.wholesalepayment;
    let adjustments = clone( this.state.manual_adjustments );
    const auth = this.props.auth;
    const user = this.props.user;
    let profile = auth.getProfile( user );
    const ADJUSTMENT_BY = profile.name;

    let adjustment = {
      SUMMARY_ID: wholesalepayment.SUMMARY_ID,
      ADJUSTMENT_ID: 0,
      PAYOUT_CODE: 'MAN_ADJ',
      PAYOUT_DESCRIPTION: '',
      PAYOUT_ADJUSTMENT: 0.00,
      ADJUSTMENT_NOTE: '',
      MODE: 'NEW',
      CHANGED: true,
      ADJUSTMENT_BY: ADJUSTMENT_BY,
    };

    adjustments.push( adjustment );

    this.setState( {
      showadjustments: true,
      manual_adjustments: adjustments
    } );
  }

  onChangeAdjustment( e ) {
    let adjustments = clone( this.state.manual_adjustments );
    const rowIndex = parseInt( e.target.rowIndex, 10 );
    const column = e.target.column;
    const value = e.target.value;
    const adjustment = adjustments[ rowIndex.toString() ];
    if( adjustment !== undefined ) {
      if( adjustment[ column ] !== undefined ) {
        adjustments[rowIndex][column] = value;
        adjustments[rowIndex]['CHANGED'] = true;
      }
    }
    this.setState( {
      manual_adjustments: adjustments
    } );
  }

  onCloseAdjustments( e ){
    this.setState( {
      showadjustments: false
    } );
  }

  onSaveAdjustments( e ) {
    const { dispatch } = this.props;
    const Bugsnag = this.props.bugsnag;
    let alerts = new Alerts( Bugsnag, dispatch );
    let wholesalepayments = clone( this.state.wholesalepayments );
    let wholesalepayment = this.state.wholesalepayment;
    const adjustments = this.state.manual_adjustments;
    const PAYEE_ID = wholesalepayment.PAYEE_ID;
    const CCFIleYYYYMM = wholesalepayment.CCFIleYYYYMM;

    let api = new EtelAPI( 'wholesale/payments/adjustment' );

    let is_valid_adjustment = true;
    let adjustment_count = 0;

    //Validate the adjustments
    if( adjustments !== undefined ) {
      if( adjustments.length > 0 ) {
        for( var index = 0; index < adjustments.length; index++ ) {
          const adjustment = adjustments[ index ];
          if( ( adjustment.MODE === 'NEW' ) || ( adjustment.MODE === 'EDIT' && adjustment.CHANGED === true ) ) {
            adjustment_count += 1;

            if ( adjustment.PAYOUT_DESCRIPTION === '' ) {
              alerts.WARNING( 'Wholesale Payment Worksheet - EOM', 'Payout description cannot be blank.', 5000 );
              is_valid_adjustment = false;
            }

            if ( parseFloat( adjustment.PAYOUT_ADJUSTMENT ) === 0.00 ) {
              alerts.WARNING( 'Wholesale Payment Worksheet - EOM', 'Payout adjustment cannot be zero.', 5000 );
              is_valid_adjustment = false;
            }

            if ( !isNaN( adjustment.PAYOUT_ADJUSTMENT ) === false ) {
              alerts.WARNING( 'Wholesale Payment Worksheet - EOM', 'Payout adjustment contains invalid characters. Reason: Not a valid number!', 5000 );
              is_valid_adjustment = false;
            }

            if ( adjustment.ADJUSTMENT_NOTE === '' ) {
              alerts.WARNING( 'Wholesale Payment Worksheet - EOM', 'Adjustment note cannot be blank.', 5000 );
              is_valid_adjustment = false;
            }
          }

          if( adjustment.MODE === 'DELETE' ) {
            adjustment_count += 1;
          }
        }
      }
    }

    //Validate that there is at least on adjustment on the list
    if( adjustment_count === 0 ){
      alerts.INFO( 'Wholesale Payment Worksheet - EOM', 'Save Failed: You did not add any adjustments.', 5000 );
      is_valid_adjustment = false;
    }

    if( is_valid_adjustment === true ) {

      for( var aindex = 0; aindex < adjustments.length; aindex++ ) {
        const adjustment = adjustments[ aindex ];

        //Insert new adjustment
        if ( adjustment.MODE === 'NEW' ) {

          let parameters = {
            PAYEE_ID: PAYEE_ID,
            PAYOUT_DESCRIPTION: adjustment.PAYOUT_DESCRIPTION,
            PAYOUT_ADJUSTMENT: parseFloat( adjustment.PAYOUT_ADJUSTMENT, 4 ),
            PAYOUT_CODE: adjustment.PAYOUT_CODE,
            ADJUSTMENT_NOTE: adjustment.ADJUSTMENT_NOTE,
            ADJUSTMENT_BY: adjustment.ADJUSTMENT_BY,
            CCFIleYYYYMM: CCFIleYYYYMM,
          };

          // Insert the new wholesale payment adjustment
          api.insert( parameters ).then( ( result ) => {

            let adjustment = result.data[0];

            for ( var index = 0; index < wholesalepayments.length; index++ ) {
              if ( parseInt( wholesalepayments[index].PAYEE_ID, 0 ) === parseInt( PAYEE_ID, 0 ) ) {
                adjustment.TRAFFIC_PROVIDER = wholesalepayments[index].PAYEE;
                wholesalepayments[index]['ITEMIZED_PAYOUT'].push( adjustment );
                wholesalepayments[index].PAYOUT_NET = ( wholesalepayments[index].PAYOUT_NET + ( adjustment.PAYOUT_ADJUSTMENT ) );
                wholesalepayments[index].PAYOUT_ADJUSTMENT = ( wholesalepayments[index].PAYOUT_ADJUSTMENT + ( adjustment.PAYOUT_ADJUSTMENT ) );
                this.setState( {showadjustments: false, wholesalepayments: wholesalepayments, adjustments_alert: ''} );
              }
            }

          } ).catch( ( exception ) => {

            this.onHandleException( exception );

          } );

        }

        //Update the existing adjustment
        if ( adjustment.MODE === 'EDIT' && adjustment.CHANGED === true ) {

          let { ADJUSTMENT_ID } = adjustment;

          let parameters = {
            ADJUSTMENT_ID: adjustment.ADJUSTMENT_ID,
            PAYOUT_DESCRIPTION: adjustment.PAYOUT_DESCRIPTION,
            PAYOUT_CODE: adjustment.PAYOUT_CODE,
            PAYOUT_ADJUSTMENT: parseFloat( adjustment.PAYOUT_ADJUSTMENT, 4 ),
            ADJUSTMENT_NOTE: adjustment.ADJUSTMENT_NOTE,
            ADJUSTMENT_BY: adjustment.ADJUSTMENT_BY,
          };

          api.update( parameters ).then( ( result ) =>{

            let adjustment = result.data[0];

            for( var index = 0; index < wholesalepayments.length; index++ ){

              let wholesalepayment = wholesalepayments[index];

              if( parseInt( wholesalepayment.PAYEE_ID , 10 ) === parseInt( PAYEE_ID, 10 ) ) {

                wholesalepayments[index].PAYOUT_ADJUSTMENT = 0;
                wholesalepayments[index].PAYOUT_NET = wholesalepayments[index].PAYOUT_GROSS;
                let itemized_payouts = wholesalepayments[index]['ITEMIZED_PAYOUT'];

                for( var sindex = 0; sindex < itemized_payouts.length; sindex++ ){
                  var itemized_payout = itemized_payouts[sindex];
                  if( parseInt( itemized_payout.ADJUSTMENT_ID, 10 ) === parseInt( ADJUSTMENT_ID, 10 ) ){
                    wholesalepayments[index]['ITEMIZED_PAYOUT'][sindex] = adjustment;
                    break;
                  }
                }
                for( var windex = 0; windex < wholesalepayments[index]['ITEMIZED_PAYOUT'].length; windex++ ) {
                  const itemized_payout = wholesalepayments[index]['ITEMIZED_PAYOUT'][ windex ];
                  wholesalepayments[index].PAYOUT_ADJUSTMENT = wholesalepayments[index].PAYOUT_ADJUSTMENT + itemized_payout.PAYOUT_ADJUSTMENT;
                  wholesalepayments[index].PAYOUT_NET = wholesalepayments[index].PAYOUT_NET + itemized_payout.PAYOUT_ADJUSTMENT;
                }
              }
            }

            this.setState( {
              showadjustments: false,
              wholesalepayments: wholesalepayments
            } );


          } ).catch( ( exception ) => {

            this.onHandleException( exception );

          } );

        }

        //Delete the existing adjustment
        if ( adjustment.MODE === 'DELETE' ) {

          let { ADJUSTMENT_ID, PAYOUT_ADJUSTMENT } = adjustment;

          api.delete( ADJUSTMENT_ID ).then( ( result ) =>{

            let new_itemized_payouts = [];

            for( var index = 0; index < wholesalepayments.length; index++ ){

              let wholesalepayment = wholesalepayments[index];

              if( parseInt( wholesalepayment.PAYEE_ID , 0 ) === parseInt( PAYEE_ID, 0 ) ){

                wholesalepayments[index].PAYOUT_ADJUSTMENT = wholesalepayments[index].PAYOUT_ADJUSTMENT - ( PAYOUT_ADJUSTMENT );

                /*
                Not sure why this code is there so just going to comment it out for now
                if( wholesalepayment.PAYOUT_ADJUSTMENT === -0 ){
                  wholesalepayment.PAYOUT_ADJUSTMENT = 0;
                }
                */

                wholesalepayments[index].PAYOUT_NET = wholesalepayments[index].PAYOUT_NET - ( PAYOUT_ADJUSTMENT );
                let itemized_payouts = wholesalepayment['ITEMIZED_PAYOUT'];

                for( var sindex = 0; sindex < itemized_payouts.length; sindex++ ){

                  var itemized_payout = itemized_payouts[sindex];

                  if( parseInt( itemized_payout.ADJUSTMENT_ID, 10 ) !== parseInt( ADJUSTMENT_ID, 10 ) ){

                    new_itemized_payouts.push( itemized_payout );

                  }

                }

                wholesalepayments[index]['ITEMIZED_PAYOUT'] = new_itemized_payouts;

                this.setState( {
                  showadjustments: false
                  , wholesalepayments: wholesalepayments
                } );
              }

            }

          } ).catch( ( exception ) => {

            this.onHandleException( exception );

          } );

          this.setState( {
            showadjustments: false,
            wholesalepayments: wholesalepayments,
          } );

        }
      }
    }
  }

  onDeleteAdjustment( e ){

    let adjustments = this.state.manual_adjustments;
    let options = e.target.eventargs;
    const rowIndex = parseInt( options.rowIndex, 0 );

    if( adjustments[rowIndex].MODE === 'EDIT' ) {
      adjustments[rowIndex].MODE = 'DELETE';
      adjustments[rowIndex].CHANGED = true;
    }

    if( adjustments[rowIndex].MODE === 'NEW' ) {
      adjustments[rowIndex].MODE = 'REMOVE';
      adjustments[rowIndex].CHANGED = true;
    }

    this.setState( {
      manual_adjustments: adjustments
    } );
  }

  render(){

    return (
      <div className="payment-worksheet-container">
        {this.onRenderAdjustments()}
        <div className='payment-worksheet'>
          <RouteTitle title='Wholesale Payment Worksheet' />
          <span className='payment-worksheet-header'>
            EOM Payouts
          </span>
          <span className='payment-worksheet-filter'>
            {this.onRenderFilter()}
          </span>
          {this.onRenderTotals()}
          <div className='payment-worksheet-content' style={{'width':'100%','overflow':'auto'}}>
            <MultiLevelGrid style={{'width':'100%','overflow':'auto'}}>
              <MultiLevelGridHeader key="WholesalePaymentHeaders" HasExpandPanel={true} width="100%">
                <MultiLevelGridHeaderColumn key="EXPAND_COLLUMN" column="EXPAND_COLLUMN" text="&nbsp;" width="5%" />
                {this.onRenderHeader()}
                <MultiLevelGridHeaderColumn column="ACTIONS" text="ACTIONS" width="10%" textAlign="left" />
              </MultiLevelGridHeader>
              <MultiLevelGridBody width="100%">
                {this.onRenderBody()}
              </MultiLevelGridBody>
              <div className="mobile-grid">
                {this.onRenderMobileBody()}
              </div>
            </MultiLevelGrid>
          </div>
        </div>
      </div>
    );

  }
}

export default withRouter(
  connect (
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( PaymentWorksheet ) );



// WEBPACK FOOTER //
// ./src/content/wholesale/payments/components/PaymentWorksheet.js